

export const INITIAL_STATE = {
  logo: "/ol-main-logo.png"
};
